<template>
    <v-container>
        <v-row>
            <v-col cols="12" md="6" xl="4">
                <div class="text-h6 text-md-h5 font-weight-bold pb-2">
                    Clients
                </div>
                <client-selector
                    :clients="clients"
                    :loading="loading"
                    background-color="white"
                    can-be-empty
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import Component from 'vue-class-component';

import { ClientSelector } from '@/components/ClientSelector';

import type { ClientUser } from '@/types/User';

const AnnouncementsClientSelectorProps = Vue.extend({
    name: 'AnnouncementsClientSelector',
    props: {
        clients: {
            type: Array as PropType<ClientUser[]>,
            default() {
                return [];
            }
        },
        loading: {
            type: Boolean,
            default() {
                return false;
            }
        }
    }
});

@Component({
    components: {
        ClientSelector
    }
})
export default class AnnouncementsClientSelector extends AnnouncementsClientSelectorProps {}
</script>
